const theme = {
  colors: {
    // black: '#000',
    // blue: '#1E64C8',
    blue30: '#FFD200',
    // nightblue: '#1E64C8',
    // nightblue10: 'rgba(30,100,200,0.1)',
    // nightblue30: 'rgba(30,100,200,0.3)',
    // nightblue50: 'rgba(30,100,200,0.5)',
    // nightblue85: 'rgba(30,100,200,0.85)',
    orange: '#E85E71',
    green: '#fff',
    // gray: '#e0e2e5',
    // lightgray: '#fafafa',
    // darkgray: '#f1f2f5',
    // white: '#ffffff',
    white10: 'rgba(255,255,255,0.1)',
    white25: 'rgba(255,255,255,0.25)',
    white30: 'rgba(255,255,255,0.3)',
    white50: 'rgba(255,255,255,0.5)',
    white85: 'rgba(255,255,255,0.85)',
    warning: 'rgb(255,152,0)',
    warning10: 'rgba(255,152,0,0.1)',
    // danger: '#ff3333',
    // danger10: 'rgba(255,51,51,0.1)',
    // success: 'rgb(28,203,150)',
    // succes10: 'rgba(28,203,150,0.1)',
    transparent: 'rgba(0,0,0,0)',
    primary: 'rgb(30,100,200)',
    primaryDarkened: 'rgba(20, 67, 133, 1)',
    primary10: 'rgba(30,100,200,0.1)',
    primary50: 'rgba(30,100,200,0.5)',
    primary85: 'rgba(30,100,200,0.85)',
    secondary: 'rgb(255,210,0)',
    secondary50: 'rgba(255,210,0,.5)',
    danger: 'rgb(220,78,40)',
    danger50: 'rgba(220,78,40,.5)',
    success: 'rgb(113,168,96)',
    black: 'rgb(0,0,0)',
    xDarkgray: 'rgb(150,150,150)',
    darkgray: 'rgb(241,242,245)',
    gray: 'rgb(224,226,229)',
    lightgray: 'rgb(250,250,250)',
    white: 'rgb(255,255,255)',
    facultyColor: '#e85e71',
  },
  fonts: {
    fontface: '"PannoTextNormal", Arial, sans-serif',
    fontfaceExtraLight: '"PannoTextLight", Arial, sans-serif',
    fontfaceLight: '"PannoTextNormal", Arial, sans-serif',
    fontfaceRegular: '"PannoTextMedium", Arial, sans-serif',
    fontfaceMedium: '"PannoTextSemiBold", Arial, sans-serif',
    fontfaceBold: '"PannoTextBold", Arial, sans-serif',
    fontfaceBeta: 'Arial, sans-serif',
    sizeH1: '160px',
    sizeH1SemiSmall: '100px',
    sizeH1Small: '80px',
    sizeH2: '50px',
    sizeH3: '35px',
    sizeButton: '20px',
    sizeBase: '18px',
    sizeSmall: '14px',
    sizeSuperSmall: '12px'
  },
  zIndex: {
    header: 2,
    drawer: 10,
    headerMobile: 11,
    overlayPage: 20,
    alert: 30,
    loaderOverlay: 40
  },
  mq: {
    medium: '768px',
    large: '1024px',
    xLarge: '1440px'

  }
};

export default theme;
